// import { createSelector } from 'reselect';

export const getActivityItem = (state:any) => state.order.activity.item;
export const getActivityIsFetching = (state:any) => state.order.activity.isFetching;
export const getActivityIsLoading = (state:any) => state.order.activity.isLoading;
export const getStatus = (state:any) => state.order.status;
